import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from "react-alert";

export default function InitialMessage() {
    let alert = useAlert();
    const [initialMessage, setinitialMessage] = useState();

    useEffect(() => {
        getInitialMessage()
    }, [])

    const getInitialMessage = (date) => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getInitialMessage`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setinitialMessage(data[0]);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos del Mensaje", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div className='container'>
            {initialMessage ? <>
                <div className='row p-2'>
                    <div className="col-md-8 text-justify">
                        <p className='colorblue'><h2 className='fw-bold fst-italic'>Bienvenidos a OIC de Gobierno Municipal de Chihuahua</h2></p>
                        <div className="">
                            <div style={{ overflow: "hidden" }}>
                                <span style={{ fontSize: "1rem" }} dangerouslySetInnerHTML={{ __html: initialMessage.content }} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 fs1r">
                        <img src={initialMessage && initialMessage.preview} alt='Mensaje Inicial' className='img-fluid' />
                        <p className='text-center colorblue'><strong>{initialMessage.nametitular}</strong> <br /> <Link to={"/message"}>{initialMessage.textlink}</Link></p>
                    </div>
                </div>
            </> : <>
                <div className='text-center'>
                    <p>Cargando...</p>
                </div>
            </>}
        </div>
    )
}
